import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { grey10 } from '@zocdoc/branding/colors';
import * as Layout from '@zocdoc/components/src/Layout';
import Blob from './blob.svg';
import Header from '../../../Shared/Header';
import HeadlinePanel from './HeadlinePanel';
import SearchBar, { SearchButton, SearchFieldLabel, SearchFieldWrapper } from '../../../Search/components/SearchBar';

class SearchPanel extends PureComponent {
    static propTypes = {
        signInDropdownText: PropTypes.string,
    };

    render() {
        return (
            <Container {...this.props}>
                <StyledHeader
                    showNavigationLinks
                    signInDropdownText={this.props.signInDropdownText}
                    transparentOnDesktop
                    useAnimatedLogo
                    useSignInDropdown
                />
                <HeadlinePanel />
                <SearchArea>
                    <PositionedSearchBar
                        isExpanded
                        searchOnSelect={false}
                        showCollapseToggle={false}
                    />
                </SearchArea>
            </Container>
        );
    }
}

const Container = styled.div`
    background: ${grey10} url(${Blob}) no-repeat;
    background-position-x: 74%;
    background-position-y: -170px;
    background-size: 995px;
    display: flex;
    flex-direction: column;
    height: ${props => props.isThemedSearch ? '519px;' : '600px;'}
    position: relative;

    > * {
        flex-shrink: 0;
    }

    ${breakpoint.medium} {
        height: 553px;
    }
`;

const SearchArea = styled(Layout.PaddedContainer)`
    margin: 0 auto auto;
    width: 100%;
`;

const primaryButtonSelector = prop =>
    props => props.theme.components.button.primary[prop];

const primaryButton = css`
    color: ${primaryButtonSelector('color')};
    background-color: ${primaryButtonSelector('bgColor')};

    &:hover, &:active {
        color: ${primaryButtonSelector('hoverActiveColor')};
        background-color: ${primaryButtonSelector('hoverActiveBgColor')};
    }
`;

const PositionedSearchBar = styled(SearchBar)`
    margin: 0 auto;
    width: 100%;
    z-index: 99;
    ${SearchFieldLabel} {
        display: none;
    }

    ${SearchFieldWrapper} + ${SearchFieldWrapper} {
        margin-top: 8px;

        ${breakpoint.medium} {
            margin-top: 0;
        }
    }

    ${SearchButton} {
        ${primaryButton}
    }
`;

const StyledHeader = styled(Header)`
    [data-test="header-mobile-menu"] {
        width: 0; // this makes the burger take up no effective space
        overflow: visible;

        // this centers the logo
        & + * {
            margin-left: auto;
            margin-right: auto;
        }
    }
`;

export default SearchPanel;
